<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" v-if="finalizado" align="center">
                <h1>Estamos confirmando tu suscripcion</h1>
                <v-progress-circular indeterminate size="50" class="mt-5" color="primary"/>
            </v-col>
            <v-col cols="12" v-else align="center">
                <h1>Tu Suscripcion ha sido Confirmada!</h1>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'ConfirmarNewsletter',
  props: ['uid'],
  data () {
    return {
      finalizado: false
    }
  },
  mounted () {
    firebase.firestore().collection('newsletter').doc(this.uid).update({
      aprobado: true
    }).then(() => {
      this.finalizado = true
    })
  }
}
</script>
